/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
    CloudUploadOutlined,
    UserOutlined,
    PlusCircleOutlined,
    CloseCircleOutlined,
} from "@ant-design/icons";
import { NavLink, useNavigate } from "react-router-dom";

// Styles
import { colors } from "assets/styles/colors";
import { Grid, Label } from "assets/styles/globalStyles";

// Types
import { FontSizes, FontWeight } from "utils/enums";
import {
    CenterText, HomepageWrapper, SearchInputWrapper
} from "./styles";

// Components
import Button from "components/Button";
import InputField from "components/InputField";
import Select from "components/Select";
import Loader from "components/Loader";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// Components
// Types


const Homepage: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(false);
    const [searchText, setSearch] = useState<any>('')
    const { t } = useTranslation();
    

    const handleSearch = () => {
        if(searchText)
        navigate('/chatgpt?searchText=' + searchText)
    }
    const handleOnChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    if (pageLoading) return <Loader />;

    return (
        <>


            <HomepageWrapper>
                <CenterText direction={(currentLang?.id) == 1 ? "rtl" : "ltr"}>
                    <h1><svg xmlns="http://www.w3.org/2000/svg" className="svg-icon" viewBox="0 0 1024 1024" version="1.1"><path d="M602.24 246.72a17.28 17.28 0 0 0-11.84-16.32l-42.88-14.4A90.56 90.56 0 0 1 490.24 160l-14.4-42.88a17.28 17.28 0 0 0-32 0L428.8 160a90.56 90.56 0 0 1-57.28 57.28l-42.88 14.4a17.28 17.28 0 0 0 0 32l42.88 14.4a90.56 90.56 0 0 1 57.28 57.28l14.4 42.88a17.28 17.28 0 0 0 32 0l14.4-42.88a90.56 90.56 0 0 1 57.28-57.28l42.88-14.4a17.28 17.28 0 0 0 12.48-16.96z m301.12 221.76l-48.32-16a101.44 101.44 0 0 1-64-64l-16-48.32a19.2 19.2 0 0 0-36.8 0l-16 48.32a101.44 101.44 0 0 1-64 64l-48.32 16a19.2 19.2 0 0 0 0 36.8l48.32 16a101.44 101.44 0 0 1 64 64l16 48.32a19.2 19.2 0 0 0 36.8 0l16-48.32a101.44 101.44 0 0 1 64-64l48.32-16a19.2 19.2 0 0 0 0-36.8z m-376.64 195.52l-64-20.8a131.84 131.84 0 0 1-83.52-83.52l-20.8-64a25.28 25.28 0 0 0-47.68 0l-20.8 64a131.84 131.84 0 0 1-82.24 83.52l-64 20.8a25.28 25.28 0 0 0 0 47.68l64 20.8a131.84 131.84 0 0 1 83.52 83.84l20.8 64a25.28 25.28 0 0 0 47.68 0l20.8-64a131.84 131.84 0 0 1 83.52-83.52l64-20.8a25.28 25.28 0 0 0 0-47.68z" /></svg>{t('analyse_your_dreams')} <br />{t('wake_up_to_brighter_days')}</h1>
                    <p>{t('understand_the_meaning_of_your_dreams_with_ahlamakom')}<br />{t('get_accurate_and')} <br />{t('enter_to_get_started')}</p>
                </CenterText>
                <SearchInputWrapper direction={(currentLang?.id) == 1 ? "rtl" : "ltr"}>
                    <input type="text" placeholder="Enter your dream here..." onChange={handleOnChangeSearch} />
                    <button onClick={() => handleSearch()} ><svg xmlns="http://www.w3.org/2000/svg" className="svg-icon" viewBox="0 0 1024 1024" version="1.1"><path d="M602.24 246.72a17.28 17.28 0 0 0-11.84-16.32l-42.88-14.4A90.56 90.56 0 0 1 490.24 160l-14.4-42.88a17.28 17.28 0 0 0-32 0L428.8 160a90.56 90.56 0 0 1-57.28 57.28l-42.88 14.4a17.28 17.28 0 0 0 0 32l42.88 14.4a90.56 90.56 0 0 1 57.28 57.28l14.4 42.88a17.28 17.28 0 0 0 32 0l14.4-42.88a90.56 90.56 0 0 1 57.28-57.28l42.88-14.4a17.28 17.28 0 0 0 12.48-16.96z m301.12 221.76l-48.32-16a101.44 101.44 0 0 1-64-64l-16-48.32a19.2 19.2 0 0 0-36.8 0l-16 48.32a101.44 101.44 0 0 1-64 64l-48.32 16a19.2 19.2 0 0 0 0 36.8l48.32 16a101.44 101.44 0 0 1 64 64l16 48.32a19.2 19.2 0 0 0 36.8 0l16-48.32a101.44 101.44 0 0 1 64-64l48.32-16a19.2 19.2 0 0 0 0-36.8z m-376.64 195.52l-64-20.8a131.84 131.84 0 0 1-83.52-83.52l-20.8-64a25.28 25.28 0 0 0-47.68 0l-20.8 64a131.84 131.84 0 0 1-82.24 83.52l-64 20.8a25.28 25.28 0 0 0 0 47.68l64 20.8a131.84 131.84 0 0 1 83.52 83.84l20.8 64a25.28 25.28 0 0 0 47.68 0l20.8-64a131.84 131.84 0 0 1 83.52-83.52l64-20.8a25.28 25.28 0 0 0 0-47.68z" /></svg>{t('analyse_your_dreams')}</button>
                </SearchInputWrapper>
                <Footer />
            </HomepageWrapper>
        </>
    );
};

export default Homepage;

